import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  loading = true;
  paymentStatus: 'success' | 'failed' | 'pending' = 'pending';
  transactionDetails: any = null;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.handlePaymentResponse();
  }

  private handlePaymentResponse(): void {
    // Get the transaction details from query params
    this.route.queryParams.subscribe(params => {
      if (!params['response']) {
        this.paymentStatus = 'failed';
        this.errorMessage = 'No payment response received';
        this.loading = false;
        return;
      }

      try {
        // Parse the response (may be encoded)
        const response = JSON.parse(decodeURIComponent(params['response']));
        this.transactionDetails = response;
        
        // Verify payment with backend
        this.verifyPayment(response.transId);
      } catch (e) {
        console.error('Error parsing payment response:', e);
        this.paymentStatus = 'failed';
        this.errorMessage = 'Invalid payment response format';
        this.loading = false;
      }
    });
  }

  private verifyPayment(transactionId: string): void {
    this.http.post(`${environment.apiUrl}/v2/verify-payment`, { 
      transactionId 
    }).subscribe({
      next: (response: any) => {
        this.paymentStatus = response.success ? 'success' : 'failed';
        if (!response.success) {
          this.errorMessage = response.message || 'Payment verification failed';
        }
        this.loading = false;
        
        // Optional: Redirect after 5 seconds
        setTimeout(() => {
          this.router.navigate(['/dashboard']);
        }, 5000);
      },
      error: (err) => {
        console.error('Payment verification error:', err);
        this.paymentStatus = 'failed';
        this.errorMessage = err.error?.message || 'Error verifying payment';
        this.loading = false;
      }
    });
  }
}